<template>
	<header class="header_warp flex flex-y-center flex-x-between">
		<div class="fontSize18 col-333 m-left20 fontWeight">迪信达物流管理系统</div>
		<!-- <div class="header-center">
			<ul class="top-menu">
				<li v-for="item in topMenuData" :key="item.label" class="top-menu-item">
					{{ item.label }}
				</li>
			</ul>
		</div> -->
		<div class="row-right">
			<div class="userInfo">
				<div class="user_img">
					<img v-if="userHeadImg" :src="userHeadImg" alt=""
						style="border-radius: 50%; border: 1px solid #efefef" />
					<img v-else src="@/assets/images/icon-user-bg.png" alt="" />
				</div>
				<div class="fontSize14 col-333 fontWeight">{{loginUserName}}</div>
				<div class="userInfoHover">
					<!-- <div @click="wxbdPageShow = true" v-if="!userInfo.userUnionid">
				    <i class="iconfont icon-weixin1" style="font-size: 16px"></i>
				    <p>微信绑定</p>
				  </div>
				  <div @click="wxjbPageShow = true" v-else-if="userInfo.userUnionid">
				    <i class="iconfont icon-weixin" style="font-size: 16px"></i>
				    <p>微信解绑</p>
				  </div> -->
					<div>
						<i class="el-icon-setting" style="font-size: 16px"></i>
						<p>个人设置</p>
					</div>
					<div @click="savePasswordSetting">
						<i class="icon-biyan iconfont" style="font-size: 16px"></i>
						<p>密码修改</p>
					</div>
					<!-- <div class="save-setting">
				    <i class="el-icon-lock" style="font-size: 16px"></i>
				    <p>安全设置</p>
				    <div class="save-type">
				      <div @click="savePhoneSetting">
				        <i class="el-icon-mobile-phone" style="font-size: 16px"></i>
				        <p>手机号修改</p>
				      </div>
				      <div @click="savePasswordSetting">
				        <i class="icon-biyan iconfont" style="font-size: 16px"></i>
				        <p>旧密码修改</p>
				      </div>
				    </div>
				  </div> -->
				</div>
			</div>
			<div class="divider">
				<span> | </span>
			</div>
			<div class="logout" @click="tolocation()" style="position: relative;" v-if="isexamine">
				<img src="@/assets/images/icon-track.png" style="width: 20px;height: auto;" alt="" />
				<span>监控</span>
			</div>
			<div class="logout" @click="toshenpi()" style="position: relative;" v-if="isexamine">
				<img src="@/assets/images/shenpi.png" style="width: 20px;height: auto;" alt="" />
				<span>审批</span>
				<div v-if="orderNum">
					<div class="messagedot col-fff fontSize14" v-if="orderNum.unaudited > 0">
					</div>
				</div>
			</div>
			<!-- <div class="logout" @click="tomessage()" style="position: relative;">
				<img src="@/assets/images/new.png" style="width: 20px;height: auto;" alt="" />
				<span>消息</span>
			</div> -->
			<div class="logout" @click="userLogout">
				<img src="@/assets/images/icon-logout.png" alt="" />
				<span>退出</span>
			</div>
		</div>
		<el-dialog title="旧密码修改" v-model="showSavePasswordModle" width="40%" center>
			<div class="dialog-container">
				<div class="dialog-row">
					<span>&emsp;&emsp;旧密码：</span>

					<div class="input-box">
						<el-input placeholder="请输入" v-model="saveItem.oldPassword" type="password">
						</el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>&emsp;&emsp;新密码：</span>

					<div class="input-box">
						<el-input placeholder="密码最少8位，必须包含大小写和数字" v-model="saveItem.password" type="password">
						</el-input>
					</div>
				</div>

				<div class="dialog-row">
					<span>确认新密码：</span>
					<div class="input-box">
						<el-input placeholder="密码最少8位，必须包含大小写和数字" v-model="saveItem.password1" type="password">
						</el-input>
					</div>
				</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<span class="btn btn-outline-default mr-50" @click="closeSave()">取消</span>
					<span class="btn bg-default" @click="submitSavePassword()">确定</span>
				</span>
			</template>
		</el-dialog>
	</header>
</template>

<script>
	import {
		computed,
		reactive,
		toRefs,
		onMounted,
		onUnmounted,
		onBeforeUnmount,
		defineComponent,
		getCurrentInstance
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		useRouter
	} from "vue-router";
	import {
		setToken,
		imgFileToBase64,
		isIdNo,
		isPhone
	} from "@/libs/tools";
	import {
		apiObj
	} from "@/config/api";

	export default defineComponent({
		emits: ["userLogout"],
		setup() {
			const {
				proxy
			} = getCurrentInstance();
			const store = useStore();
			const router = useRouter();

			// 顶部菜单数据
			const topMenuData = [{
					label: '首页'
				},
				{
					label: '关于我们'
				},
				{
					label: '服务'
				},
				{
					label: '联系我们'
				},
			];

			// 数据
			const data = reactive({
				loginUserName: "",
				userHeadImg: proxy.$storage.get("userHeadImg"),
				orderNum: null,
				timer: null,
				showSavePasswordModle: false,
				saveItem: {
					userId: proxy.$storage.get("userId"),
					userName: "",
					oldPassword: "",
					password: "",
					password1: "",
				},
				isexamine: false,
			});

			const userLogout = () => {
				proxy.$confirm("是否退出!", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					proxy.$http.post("/auth/logins/logout").then((res) => {
						// todo 用户退出登录
						proxy.$storage.set("nqdjglRoleList", []); //登录者角色
						proxy.$storage.set("nqdjglUserInfo", {}); //登录者信息
						setToken(""); //设置token
						proxy.$storage.set("isLogin", false); //登录验证 全局拦截标识
						proxy.$router.push("login");
						//console.log(res);
						proxy.$bus.all.clear(); //清除所有线程
						store.commit("handleTabsIndex", 0);
						store.commit("handleTabsList", []);
					});
				});
			};

			const tolocation = () => {
				//window.open('vehicleMap', '_blank');
				//限制同一个页面中只能打开一个浏览器窗口标签
				if (window.name === 'vehicleMap') {
					// 如果窗口已经打开，则不执行任何操作
					alert('窗口已经打开！');
				} else {
					// 打开新窗口并设置名称
					const newWindow = window.open('vehicleMap', 'vehicleMap');
					newWindow.name = 'vehicleMap'; // 设置窗口名称
				}
			};

			const toshenpi = () => {
				let item1 = {
					id: "F12_01",
					text: "审批管理",
					state: null,
					selected: false,
					disabled: false,
					attributes: {
						icon: "http://dxdcaross.bdzlink.cn/lng/config/2022-05-28/1653723276864.png",
						url: "shenpiManage"
					},
				};

				// const index = store.state.keeptabsList.findIndex(item => item === item1.attributes.url)
				// if (index === -1) {
				// 	store.state.keeptabsList.push(item1.attributes.url);
				// }

				store.state.tabsList.push(item1);
				let currindex = store.state.tabsList.findIndex(item => item.id === item1.id);

				let tabsIndex = store.state.tabsIndex;
				let newList = deWeightThree(store.state.tabsList);
				store.commit("handleTabsList", newList);
				store.commit("handleTabsIndex", currindex);
				router.push({
					name: item1.attributes.url,
					replace: true,
				});
			};

			const tomessage = () => {
				let item1 = {
					id: "F07_01",
					text: "消息中心",
					state: null,
					selected: false,
					disabled: false,
					attributes: {
						icon: "http://dxdcaross.bdzlink.cn/lng/config/2022-05-28/1653723276864.png",
						url: "messageManage"
					},
				};

				// const index = store.state.keeptabsList.findIndex(item => item === item1.attributes.url)
				// if (index === -1) {
				// 	store.state.keeptabsList.push(item1.attributes.url);
				// }

				store.state.tabsList.push(item1);
				let currindex = store.state.tabsList.findIndex(item => item.id === item1.id);

				let tabsIndex = store.state.tabsIndex;
				let newList = deWeightThree(store.state.tabsList);
				store.commit("handleTabsList", newList);
				store.commit("handleTabsIndex", currindex);
				router.push({
					name: item1.attributes.url,
					replace: true,
				});
			};

			//去重
			const deWeightThree = (list) => {
				let map = new Map();

				list.forEach((item) => {
					map.set(item.id, item);
				});
				let newList = [...map.values()];
				return newList;
			};

			//获取运单状态数量
			const getOrderListCount = async () => {
				let params = {
					startTime: "",
					endTime: "",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderCount, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.orderNum = r;
				}

			};

			//安全设置 弹框
			const savePasswordSetting = () => {
				data.showSavePasswordModle = true;
			};

			//安全设置 关闭
			const closeSave = () => {
				data.showSavePasswordModle = false;
			};

			//提交安全设置
			const submitSavePassword = () => {
				if (data.saveItem.oldPassword == "") {
					proxy.$message.error("请输入原始密码");
					return;
				}
				if (data.saveItem.password == "") {
					proxy.$message.error("请输入新密码");
					return;
				}
				if (data.saveItem.password1 == "") {
					proxy.$message.error("请确认新密码");
					return;
				}
				if (data.saveItem.password != data.saveItem.password1) {
					proxy.$message.error("密码不一致");
					return;
				}
				if (data.saveItem.password.length < 8) {
					proxy.$message.error("密码最少设置8位");
					return;
				}
				// if (!/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)/.test(data.saveItem.password)) {
				//   proxy.$message.error("密码必须包含大小写字母和数字");
				//   return;
				// }
				let params = {
					userId: data.saveItem.userId,
					oldPassword: data.saveItem.oldPassword,
					password: data.saveItem.password,
				};
				proxy.$http
					.postFormData(apiObj.userChangePassword, params, {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						},
					})
					.then((res) => {
						if (res.code == 0 || res.respCode == "0000") {
							proxy.$message.success(res.respMsg);
							data.showSavePasswordModle = false;
						} else {
							proxy.$message.error(res.respMsg);
							data.saveItem.oldPassword = "";
							data.saveItem.password = "";
							data.saveItem.password1 = "";
						}
					});
			};

			const onShow = () => {
				getOrderListCount();
			};


			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "examine") {
						data.isexamine = true;
					}
				});

				if (proxy.$storage.get("loginUserName")) {
					data.loginUserName = proxy.$storage.get("loginUserName");
				}
				getOrderListCount();
				// data.timer = setInterval(() => {
				// 		getOrderListCount();
				// }, 6000);

				document.addEventListener('visibilitychange', onShow);

			});


			onUnmounted(() => {
				document.removeEventListener('visibilitychange', onShow);
			});

			onBeforeUnmount(() => {
				// if (data.timer) {
				// 	clearInterval(data.timer); // 清除定时器以避免内存泄漏
				// }
			});

			return {
				...toRefs(data),
				userLogout,
				toshenpi,
				tomessage,
				tolocation,
				savePasswordSetting,
				closeSave,
				submitSavePassword,
				topMenuData
			};
		},
	});
</script>

<style scoped>
	.header_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
	}

	.logout {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
	}

	.logout img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.divider {
		margin-left: 20px;
		margin-right: 15px;
	}

	.user_warp {
		margin-right: 10px;
		position: relative;
		cursor: pointer;
	}

	.user_img {
		width: 40px;
		height: 40px;
		border: 1px solid rgb(239, 239, 239);
		border-radius: 50%;
		margin-right: 10px;
	}

	.user_img img {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}

	.messagedot {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		background: red;
		left: 0;
		bottom: 0;
	}

	.row-right {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.row-right .userInfo,
	.row-right .logout {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
	}

	.row-right .userInfo img {
		width: 40px;
		height: 40px;
		margin-right: 5px;
	}

	.row-right .userInfo span {
		font-size: 15px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #333333;
	}

	.userInfo:hover .userInfoHover {
		display: block;
	}

	.userInfoHover {
		position: absolute;
		left: -40px;
		top: 40px;
		width: 150px;
		height: 175px;
		background-image: url("../../../../assets/images/setting-bg.png");
		background-size: cover;
		z-index: 999;
		display: none;
	}

	.userInfoHover>div {
		height: 41px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.userInfoHover>div:nth-of-type(1) {
		padding-top: 30px;
	}

	.userInfoHover>div>p {
		display: inline-block;
		font-size: 14px;
		color: #222222;
		margin-left: 10px;
	}

	.save-setting {
		position: relative;
	}

	.save-setting:hover .save-type {
		display: block;
	}

	.save-type {
		width: 120px;
		padding-top: 10px;
		position: absolute;
		background: #ffffff;
		left: 120px;
		top: 20px;
		display: none;
		box-shadow: 0px 0px 5px 0px rgba(66, 66, 66, 0.15);
		border-radius: 10px;
	}

	.save-type>div {
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}

	.save-type>div>p {
		font-size: 14px;
		color: #222222;
		display: inline-block;
		margin-left: 5px;
	}

	.row-right .logout {
		cursor: pointer;
	}

	.row-right .logout img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.row-right .logout span {
		font-size: 15px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #333333;
	}

	.row-right .divider {
		margin-left: 20px;
		margin-right: 15px;
	}

	.dialog-container .dialog-row {
		width: 100%;
		height: 50px;
		margin-bottom: 10px;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-container .dialog-row .dialog-row-left {
		min-width: 130px;
		text-align: right;
	}

	.dialog-container .dialog-row .input-box {
		width: 50%;
		height: 100%;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-container .dialog-row .input-box input[type="text"],
	.dialog-container .dialog-row .input-box input[type="number"],
	.dialog-container .dialog-row .input-box select {
		width: 100%;
		height: 33px;
		border: 1px solid #f5f5f5;
	}

	.dialog-container .dialog-row .input-box input[type="text"],
	.dialog-container .dialog-row .input-box input[type="number"] {
		padding-left: 5px;
	}

	.dialog-container .dialog-row .input-box select {
		cursor: pointer;
	}

	.dialog-container .dialog-row .input-box input[type="text"]:focus,
	.dialog-container .dialog-row .input-box select:focus {
		outline: none;
	}

	.dialog-container .blank-img {
		display: inline-block;
		width: 72px;
		height: 72px;
		background: #f5f5f5;
	}

	.dialog-container .btn {
		padding: 5px 15px;

		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dialog-footer .btn {
		padding: 8px 30px;
		color: #333;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.header-center .top-menu {
		display: flex;
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.top-menu-item {
		margin: 0 15px;
		cursor: pointer;
	}

	.top-menu-item:hover {
		text-decoration: underline;
	}
</style>